// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1fcHy","paramInput":"JobSimulator_paramInput__1huqp","input":"JobSimulator_input__2xXZ5"};